import { injectable } from 'inversify';
import { IFieldInfo } from '../interfaces/IFieldInfo';

export class ConfigData {
  sessionManagerUrl = '';

  contextualServiceUrl = '';

  dataBroadcasterUrl = '';

  pitchComServiceUrl = '';

  teamExclusiveLeagueId = '';

  teamExclusiveLeagueName = '';

  teamExclusiveGameLevelId = '';

  teamExclusiveGameLevelName = '';

  liveDashboardUrl = '';

  appVersion = '';

  availableFields: IFieldInfo[] = [];

  activeField: IFieldInfo | undefined;

  isUserLogged = false;

  isBackfield = false;
}

export interface IConfigurationService {
  getConfigs(): ConfigData;
  fetchConfigs(): Promise<ConfigData>;
  getWindowOrigin(includeRelativePath: boolean): string;
}

@injectable()
export class ConfigurationService implements IConfigurationService {
  private static configs: ConfigData;

  getConfigs() {
    return ConfigurationService.configs;
  }

  async fetchConfigs(): Promise<ConfigData> {
    const data = await fetch(`${this.getWindowOrigin(true)}/Home/Config`, {
      credentials: 'include',
    });
    try {
      const jsonConfig = await data.json();

      for (const key in jsonConfig) {
        if (jsonConfig.hasOwnProperty(key) && typeof jsonConfig[key] === 'string') {
          jsonConfig[key] = (jsonConfig[key] as string).replace('{WINDOWORIGIN}', this.getWindowOrigin(false));
        }
      }

      ConfigurationService.configs = jsonConfig;
      if (ConfigurationService.configs.activeField === null) {
        ConfigurationService.configs.activeField = undefined;
      }
      return ConfigurationService.configs;
    } catch (ex) {
      console.log(ex);
      return (ConfigurationService.configs = {
        sessionManagerUrl: '',
        contextualServiceUrl: '',
        dataBroadcasterUrl: '',
        pitchComServiceUrl: '',
        teamExclusiveGameLevelId: '',
        teamExclusiveGameLevelName: '',
        teamExclusiveLeagueName: '',
        teamExclusiveLeagueId: '',
        liveDashboardUrl: '',
        appVersion: '',
        availableFields: [],
        activeField: undefined,
        isBackfield: false,
        isUserLogged: false,
      });
    }
  }

  getWindowOrigin(includeRelativePath: boolean): string {
    if (process.env.NODE_ENV === 'development') {
      return `http://localhost:${process.env.REACT_APP_DEV_PORT}`;
    }
    if (process.env.NODE_ENV === 'production') {
      if (!window.location.origin) {
        (window.location as any).origin = `${window.location.protocol}//${window.location.hostname}${
          window.location.port ? `:${window.location.port}` : ''
        }`;
      }
    }

    if (includeRelativePath) {
      return `${window.location.origin}/taggingapp`;
    }

    return window.location.origin;
  }
}
